// SweetAlert.js
import React from 'react';
import Swal from 'sweetalert2';

const SweetAlert = ({ title, text, type }) => {
    Swal.fire({
        title: title,
        text: text,
        icon: type,
        confirmButtonColor: '#3085d6',
        confirmButtonText: 'OK',
    });

    // Note: You may want to handle the promise returned by Swal.fire() for more advanced scenarios.

    return null; // React components must return something, but SweetAlert is used for its side effect.
};

export default SweetAlert;
